import { BaseModel } from "sjs-base-model";
import AppModel from "../app/AppModel";

const USER_LOGIN = "userLogin";
const NAME = "name";
const SURNAME = "surname";
const EMAIL = "email";
const ACTIVE = "active";
const LANG = "lang";
const IMAGE = "image";
const ACTIVATED = "accessActivated";
const CORPORATIVE = "corporative";
const CHANGE_PASSWORD = "changePassword";
const APPS = "apps";
const IS_ADMIN = "isAdmin";
const RESPONSIBLE_APPS = "managerApps"; //apps de las que el usuario es responsable
const SUPER_RESPONSIBLE_APPS = "superManager"; //apps de las que el usuario es super responsable (validador de admins)

export const USER_PROPERTIES = {
  USER_LOGIN: USER_LOGIN,
  NAME: NAME,
  SURNAME: SURNAME,
  EMAIL: EMAIL,
  ACTIVE: ACTIVE,
  LANG: LANG,
  ACTIVATED: ACTIVATED,
  CORPORATIVE: CORPORATIVE,
  APPS: APPS,
  CHANGE_PASSWORD: CHANGE_PASSWORD,
  IS_ADMIN: IS_ADMIN,
  IMAGE: IMAGE,
  RESPONSIBLE_APPS: RESPONSIBLE_APPS,
};

const SAVE_PROPERTIES = [USER_LOGIN, NAME, SURNAME, EMAIL, ACTIVE, LANG, ACTIVATED, CORPORATIVE];

export default class UserModel extends BaseModel {
  [USER_LOGIN] = null;
  [NAME] = null;
  [SURNAME] = null;
  [EMAIL] = null;
  [LANG] = null;
  [IMAGE] = null;
  [ACTIVE] = true;
  [ACTIVATED] = false;
  [CORPORATIVE] = false;
  [CHANGE_PASSWORD] = false;
  [IS_ADMIN] = false;
  [RESPONSIBLE_APPS] = [];
  [SUPER_RESPONSIBLE_APPS] = false;
  [APPS] = [];

  constructor(data) {
    super();
    if (data[APPS]) {
      data[APPS] = data[APPS].map((a) => new AppModel(a));
    }
    this.update(data);
  }

  getId = () => this[USER_LOGIN];
  getName = () => this[NAME];
  getImage = () => this[IMAGE];
  getSurname = () => this[SURNAME];
  getFullName = () => `${this[NAME]} ${this[SURNAME] || ""}`;
  getFullNameWidthLogin = () => `${this[NAME]} ${this[SURNAME] || ""} (${this[USER_LOGIN]})`;
  getEmail = () => this[EMAIL];
  getLogin = () => this[USER_LOGIN];
  getLang = () => this[LANG];
  getShowName = () => `${this[NAME]} ${this[SURNAME] || ""}`;
  getApps = () => this[APPS];
  getChangePassword = () => this[CHANGE_PASSWORD];
  getIsAdmin = () => this[IS_ADMIN];
  getResponsibleApps = () => this[RESPONSIBLE_APPS];
  getSuperResponsibleApps = () => this[SUPER_RESPONSIBLE_APPS];
  // getResponsibleApps = () =>
  //   this[APPS].filter((app) => this.getIsAdmin() || app.getResponsibles().indexOf(this.getId()) !== -1); //TODO cambiar esto y dejar solo los responsables?
  // getShowName = () => `${this[NAME]} ${this[SURNAME] || ""} (${this[USER_LOGIN]})`;
  isActivated = () => this[ACTIVATED];
  isCorporative = () => this[CORPORATIVE];
  isActive = () => this[ACTIVE];
  getModelProperty = (p) => this[p];
  setModelProperty = (property, value) => (this[property] = value);
  setLang = (v) => (this[LANG] = v);
  setApps = (v) => (this[APPS] = v);

  isDifferent = (otherItem) => {
    return SAVE_PROPERTIES.find((p) => otherItem[p] !== this[p]);
  };

  getSaveFields = () => {
    let resp = {};
    SAVE_PROPERTIES.forEach((p) => (resp[p] = this[p]));
    return resp;
  };

  getSaveLangFields = () => {
    return { [LANG]: this[LANG] };
  };
}
